import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../../components/Button';
import type { Group } from '../../types';

interface GroupHeaderProps {
    group: Group | null;
}

export const GroupHeader: React.FC<GroupHeaderProps> = ({ group }) => {
    const navigate = useNavigate();

    return (
        <>
            <div className="fixed top-0 left-0 right-0 z-40 bg-bg-header border-b border-border-default shadow-sm">
                <div className="max-w-md mx-auto px-4 py-3 flex items-center gap-4">
                    <Button variant="ghost" size="icon" onClick={() => navigate('/')}>
                        <ArrowLeft className="h-5 w-5" />
                    </Button>
                    <div>
                        <h2 className="text-2xl font-bold text-text-heading">{group ? group.name : 'Loading...'}</h2>
                        {group && <p className="text-xs font-mono text-text-muted uppercase">Code: {group.code}</p>}
                    </div>
                </div>
            </div>
            <div className="h-[72px] w-full" />
        </>
    );
};
